query gradeLevel ($id: ID!, $sortBy: StudentSort, $sortDirection: Direction, $page: Int) {
  gradeLevel(id: $id) {
    canCurrentDelete
    name
    color {
      id
      name
      displayName
    }
    icon {
      id
      name
      displayName
    }
    id
    order
    orderDenominator
    orderNumerator
    studentList(sortBy: $sortBy, sortDirection: $sortDirection, page: $page) {
      list {
        id
        first
        last
        positivity
        mostRecentCommunication
        communicationCount
        gradeLevel {
          id
          name
          order
        }
      }
      count
      remaining
      pageSize
    }
  }
}
